import { useEffect } from 'react';

// ⚠️ IMPORTANTE: Altere para o seu GTM ID
const GTM_ID = 'GTM-5GMHVC93';

// Declaração de tipos para o dataLayer
declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

// Hook para inicializar GTM
export function useGTM() {
  useEffect(() => {
    // Inicializar dataLayer se não existir
    window.dataLayer = window.dataLayer || [];
    
    // Script do GTM
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(script);
    
    // Noscript fallback
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
    
    return () => {
      // Cleanup se necessário
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
}

// Função para enviar eventos para GTM
export function pushGTMEvent(eventData: Record<string, unknown>) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(eventData);
  }
}
